import React, { useEffect, useState } from "react";
import imagePlaceholder from "../../svg/bg.jpg";
import { Input, Button, Progress, Skeleton, Drawer } from "antd";
import { MailOutlined, PlusOutlined, SearchOutlined, MenuOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { paymentActions } from "../../redux/paymentSlice";
import { eventActions } from "../../redux/eventSlice";
import { Link, useNavigate } from "react-router-dom";
import Item from "antd/es/list/Item";
import { convertToNepaliDate } from "../../components/FormatDate";

const DashboardHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  
  const { payments, loading: paymentsLoading } = useSelector(
    (state) => state.payments
  );
  const { events, loading: eventsLoading } = useSelector(
    (state) => state.events
  );
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("User in DashboardHome:", user);
  const { Search } = Input;
  const currentAmount = 32300;
  const targetAmount = 59000;
  const percent = (currentAmount / targetAmount) * 100;

  useEffect(() => {
    dispatch(paymentActions.getPayments());
    dispatch(eventActions.getEvents());
  }, [dispatch]);

  const recentPayments = [...payments]
    .sort(
      (a, b) =>
        new Date(b?.payment?.created_at) - new Date(a?.payment?.created_at)
    )
    .slice(0, 3);

  const getStatusColor = (status) => {
    switch (status) {
      case "Confirmed":
        return "bg-green-800";
      case "Pending":
        return "bg-yellow-800";
      case "Rejected":
        return "bg-red-800";
      default:
        return "bg-gray-800";
    }
  };

  const isOverdue = (createdAt) => {
    const created = new Date(createdAt);
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
    return created < threeMonthsAgo;
  };

  const overduePayments = payments
    .filter((p) => {
      const pay = p.payment ?? p;
      return pay.status !== "Confirmed" && isOverdue(pay.created_at);
    })
    .sort((a, b) => {
      const dateA = new Date((a.payment ?? a).created_at).getTime();
      const dateB = new Date((b.payment ?? b).created_at).getTime();
      return dateA - dateB;
    });

  const handleNavigation = (user) => {
    const noticeType = "private";
    const selectedUser = user;

    navigate("/dashboard/notices", {
      state: {
        noticeType,
        selectedUser,
      },
    });
    setDrawerVisible(false);
  };

  const navigationItems = [
    { title: "Dashboard", path: "/dashboard" },
    { title: "Payments", path: "/dashboard/payments" },
    { title: "Events", path: "/dashboard/events" },
    { title: "Notices", path: "/dashboard/notices" },
    { title: "Add Invoice", path: "/dashboard/addinvoice" },
    { title: "Reports", path: "/dashboard/reports" },
    { title: "Settings", path: "/dashboard/settings" },
  ];

  return (
    <div className="w-full max-w-full overflow-x-hidden ml-0 sm:ml-250">
      <div className="px-4 sm:px-6 lg:px-8 py-4">
        {/* Header Section */}
        <div className="flex flex-col gap-4">
          {/* Top Row - User Profile and Hamburger */}
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center flex-1 min-w-0">
              <img
                src={user?.profile_picture_url || imagePlaceholder}
                className="h-10 w-10 rounded-full object-cover flex-shrink-0"
                alt="profile"
              />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold truncate">{user?.user?.name}</p>
                <p className="text-xs text-gray-600 truncate">{user.role}</p>
              </div>
            </div>
            
            {/* Hamburger Menu Button */}
            {/* <Button
              icon={<MenuOutlined />}
              onClick={() => setDrawerVisible(true)}
              className="lg:hidden"
              size="large"
            /> */}
          </div>

          {/* Second Row - Search and Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* Search Bar */}
            <div className="flex-1">
              <Search
                placeholder="Search residences"
                enterButton={
                  <Button
                    icon={<SearchOutlined className="text-white" />}
                    style={{ backgroundColor: "#CA8A04" }}
                  />
                }
                size="large"
              />
            </div>

            {/* Desktop Navigation - Hidden on mobile */}
            <div className="hidden lg:flex gap-2">
              <Link to="/dashboard/addinvoice">
                <Button
                  type="default"
                  className="bg-green-800 text-white hover:bg-green-600 px-6 h-10 rounded-xl whitespace-nowrap"
                  icon={<PlusOutlined />}
                >
                  Add Invoice
                </Button>
              </Link>
            </div>
          </div>

          {/* Third Row - Collection Status */}
          <div className="bg-[#CA8A04] p-3 rounded-xl">
            <div className="flex flex-wrap gap-2 items-center mb-2">
              <p className="text-sm font-semibold text-white">
                Collection Status
              </p>
              <p className="text-xs text-white/90">
                Rs {currentAmount} / Rs {targetAmount}
              </p>
            </div>
            <div className="w-full h-2.5 bg-red-700 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-600 rounded-full transition-all"
                style={{ width: `${percent}%` }}
              />
            </div>
          </div>
        </div>

        {/* Hamburger Drawer */}
        <Drawer
          title="Menu"
          placement="right"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          width={280}
        >
          <div className="flex flex-col gap-2">
            {navigationItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                onClick={() => setDrawerVisible(false)}
              >
                <Button
                  type="text"
                  className="w-full text-left justify-start h-12 text-base hover:bg-gray-100"
                >
                  {item.title}
                </Button>
              </Link>
            ))}
          </div>
        </Drawer>

        {/* Dashboard Title */}
        <div className="text-2xl font-bold mt-6 mb-4">Dashboard</div>

        {/* Main Content - Two Column Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Left Column */}
          <div className="flex flex-col gap-6">
            {/* Recent Payments */}
            <div className="p-4 bg-white shadow-md rounded-lg">
              <h2 className="text-lg font-semibold border-b border-black pb-2 mb-4">
                Recent Payment Received
              </h2>

              {paymentsLoading ? (
                <Skeleton active paragraph={{ rows: 4 }} />
              ) : recentPayments.length === 0 ? (
                <p className="text-center text-gray-500 py-4">No recent payments</p>
              ) : (
                <div className="space-y-3">
                  {recentPayments.map((item) => (
                    <div
                      key={item?.payment?.id || item?.id}
                      className="flex items-center gap-3 border-b pb-3 last:border-b-0"
                    >
                      <img
                        src={item?.slip_url}
                        alt="Payment slip"
                        className="h-12 w-12 rounded-lg object-cover flex-shrink-0"
                      />
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm truncate">
                          {item?.user_name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {convertToNepaliDate(new Date(item?.created_at))}
                        </p>
                      </div>
                      <div className="flex flex-col items-end gap-1 flex-shrink-0">
                        <span
                          className={`px-2 py-1 rounded-md text-white text-xs ${getStatusColor(
                            item?.payment?.status
                          )}`}
                        >
                          {item?.payment?.status}
                        </span>
                        <p className="text-sm font-bold whitespace-nowrap">
                          Rs {item?.payment?.amount || item?.amount}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Overdue Payments */}
            <div className="p-4 bg-white shadow-md rounded-lg">
              <div className="border-b border-black pb-2 mb-4">
                <h2 className="text-lg font-semibold">
                  Overdue Payment Alert
                </h2>
                <p className="text-xs text-gray-600 mt-1">
                  (Overdue up to 3 months)
                </p>
              </div>

              {paymentsLoading ? (
                <Skeleton active paragraph={{ rows: 4 }} />
              ) : overduePayments.length === 0 ? (
                <p className="text-center text-gray-500 py-4 text-sm">
                  No overdue payments
                </p>
              ) : (
                <div className="space-y-3">
                  {overduePayments.map((item) => {
                    const pay = item.payment ?? item;
                    return (
                      <div
                        key={pay.id}
                        className="flex flex-col sm:flex-row items-start sm:items-center gap-3 border-b pb-3 last:border-b-0"
                      >
                        <div className="flex items-center gap-3 flex-1 min-w-0 w-full sm:w-auto">
                          <img
                            src={item.slip_url || "https://via.placeholder.com/48"}
                            alt="slip"
                            className="h-12 w-12 rounded-lg object-cover flex-shrink-0"
                          />
                          <div className="min-w-0 flex-1">
                            <p className="font-semibold text-sm truncate">
                              {item.user_name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {convertToNepaliDate(new Date(pay.created_at))}
                            </p>
                          </div>
                          <p className="text-sm font-bold text-red-700 whitespace-nowrap sm:hidden">
                            Rs {pay.amount}
                          </p>
                        </div>
                        <Button
                          icon={<MailOutlined />}
                          onClick={() => handleNavigation(user)}
                          className="bg-[#403F93] text-white text-xs w-full sm:w-auto"
                          size="small"
                        >
                          Send Reminder
                        </Button>
                        <p className="hidden sm:block text-sm font-bold text-red-700 whitespace-nowrap">
                          Rs {pay.amount}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-6">
            {/* Upcoming Events */}
            <div className="p-4 bg-white shadow-md rounded-lg">
              <h2 className="text-lg font-semibold border-b border-black pb-2 mb-4">
                Upcoming Events
              </h2>

              {eventsLoading ? (
                <Skeleton active paragraph={{ rows: 4 }} />
              ) : events.length === 0 ? (
                <p className="text-center text-gray-500 py-4 text-sm">
                  No upcoming events
                </p>
              ) : (
                <div className="space-y-3">
                  {events.map((item) => (
                    <div
                      key={item?.id}
                      className="flex items-center gap-3 border-b pb-3 last:border-b-0"
                    >
                      {item?.file_url ? (
                        <img
                          src={item.file_url}
                          alt={item.name}
                          className="h-12 w-12 rounded-lg object-cover flex-shrink-0"
                        />
                      ) : (
                        <div className="h-12 w-12 bg-gray-200 rounded-lg flex items-center justify-center flex-shrink-0">
                          <span className="text-xs text-gray-500">No Img</span>
                        </div>
                      )}
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm truncate">
                          {item?.name}
                        </p>
                        <p className="text-xs text-gray-500">
                          {(item?.date)} at{" "}
                          {item?.time}
                        </p>
                        <p className="text-xs text-gray-600 truncate">
                          {item?.venue}
                        </p>
                      </div>
                      <Link to={`/dashboard/singleevent/${item?.id}`}>
                        <Button className="bg-yellow-600 text-white text-xs flex-shrink-0" size="small">
                          See More
                        </Button>
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Upcoming Tasks */}
            <div className="p-4 bg-white shadow-md rounded-lg">
              <h2 className="text-lg font-semibold border-b border-black pb-2 mb-4">
                Upcoming Tasks
              </h2>
              <div className="space-y-3">
                {[
                  { title: "Collect water reading", date: "3 mangsir 2081" },
                  { title: "Issue community fee bills", date: "12 mangsir 2081" },
                  { title: "Send reminder for payment", date: "13 mangsir 2081" },
                  { title: "Submit audit report", date: "6 poush 2081" },
                ].map((task, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 border-b pb-3 last:border-b-0"
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/4345/4345800.png"
                      alt="Task icon"
                      className="h-12 w-12 rounded-lg object-cover flex-shrink-0"
                    />
                    <div className="flex-1 min-w-0">
                      <p className="font-semibold text-sm">{task.title}</p>
                      <p className="text-xs text-gray-500">{task.date}</p>
                    </div>
                    <Button className="bg-yellow-600 text-white text-xs flex-shrink-0" size="small">
                      See More
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;